import { useState, useCallback } from 'react';
import { useQuery } from '@apollo/client';
import { GET_CLOSEST_STORE_ZIPCODE } from 'mocks/queries';
import { ZIP_CODE_REGEX, ZIPCODE_ERROR_MESSAGES } from 'commons/constants';
import useSetZipCodeFromUser from 'global-state/zipCodeFromUser/useSetZipCodeFromUser';
import storesData from 'hooks/useClosestStoreZipcode/stores.json';

export const validateZipcodeInput = inputs => {
  if (!inputs.zipcode.toString().trim()) {
    return { zipcode: ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_EMPTY };
  }

  if (!ZIP_CODE_REGEX.test(inputs.zipcode)) {
    return { zipcode: ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_INVALID_FORMAT };
  }

  return {};
};

const useShowroomLocator = () => {
  const [searchZipcode, setSearchZipcode] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const setZipCodeFromUser = useSetZipCodeFromUser();

  const { data: storeZipData, loading, error } = useQuery(
    GET_CLOSEST_STORE_ZIPCODE,
    {
      variables: { zipcode: searchZipcode },
      skip: !hasSearched || !searchZipcode,
      errorPolicy: 'all',
    }
  );

  const storeZip = storeZipData?.getClosestStoreFromZipcode;

  let storeLocation = null;

  if (storeZip && storeZip !== 'virtual' && storeZip !== 'null') {
    storeLocation = storesData[storeZip];
  } else if (hasSearched && !loading && searchZipcode) {
    storeLocation = storesData[searchZipcode];
  }

  const handleSearch = useCallback(
    zipcode => {
      const trimmedZipCode = zipcode.trim();
      setSearchZipcode(trimmedZipCode);
      setHasSearched(true);
      setZipCodeFromUser(trimmedZipCode);
    },
    [setZipCodeFromUser]
  );

  const handleCloseResults = useCallback(() => {
    setHasSearched(false);
  }, []);

  const handleViewAll = useCallback(() => {
    setSearchZipcode('');
    setHasSearched(false);
  }, []);

  return {
    storeLocation,
    loading,
    error,
    hasSearched,
    handleSearch,
    handleCloseResults,
    handleViewAll,
  };
};

export default useShowroomLocator;
